import script from "./Originals.vue?vue&type=script&setup=true&lang=js"
export * from "./Originals.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__